import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-stone-50/70 border-b border-stone-200/60"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="/" data-testid="brand-logo" className="font-serif text-3xl tracking-tight leading-none">
          Stylo<span style={{ color: "#E63946" }}>.</span>
        </a>
        <nav className="hidden md:flex items-center gap-10 text-sm font-medium text-stone-600">
          <a href="#features" className="hover:text-stone-900 transition-colors" data-testid="nav-features">Design</a>
          <a href="#prototypes" className="hover:text-stone-900 transition-colors" data-testid="nav-prototypes">Editions</a>
          <a href="#market" className="hover:text-stone-900 transition-colors" data-testid="nav-market">Opportunity</a>
          <a href="#vision" className="hover:text-stone-900 transition-colors" data-testid="nav-vision">Vision</a>
        </nav>
        <a
          href="#preorder"
          data-testid="nav-cta"
          className="h-11 px-6 rounded-full bg-stone-900 text-stone-50 text-sm font-semibold flex items-center hover:bg-stone-700 transition-colors"
        >
          Pre-order
        </a>
      </div>
    </motion.header>
  );
};
